import type { FirmDomain } from "@/shared/utils/firm";

export interface HardcodedParams {
  /**
   * First day of the week for calendar views.
   * 0 = Sunday, 1 = Monday. Two options only.
   * Date pickers use the react-day-picker default (Sunday) and are unaffected.
   */
  weekStartsOn: 0 | 1;
  /** Identical transaction rows are exported independently for this firm. */
  identicalDuplicatesExportable?: boolean;
}

/**
 * Per-firm feature flags.
 * `useHardcodedParams()` always returns a fully-typed, non-undefined value.
 */
export const HARDCODED_PARAMS: Record<FirmDomain, HardcodedParams> = {
  hourglass: { weekStartsOn: 0 },
  pregodonnell: { weekStartsOn: 0 },
  tysonmendes: { weekStartsOn: 1 },
  bpmlaw: { weekStartsOn: 0 },
  taylorday: { weekStartsOn: 0 },
  namanhowell: { weekStartsOn: 0 },
  gouldratner: { weekStartsOn: 0, identicalDuplicatesExportable: true },
  unknown: { weekStartsOn: 0 },
};
